export default {
  List: require('./List').default,
}